import React, { useState } from 'react';
import { AdminBarChart, DistributionList } from '../../components/admin/AdminChart';
import { AdminMetricCard, AdminPageTitle, DateRange, Panel } from '../../components/admin/AdminPrimitives';
import { DataTable, type Column } from '../../components/admin/DataTable';
import { metricUsage, sportAdoption } from '../../data/admin';
type Row = (typeof sportAdoption)[number];
export function AdminSports() {
  const [range, setRange] = useState('90d');
  const columns: Column<Row>[] = [{
    id: 'sport',
    header: 'Esporte',
    sortValue: row => row.sport,
    cell: row => <span className="text-[13px] font-medium text-deep" data-id="element-1820" data-mp="yyeth9kq79kl">{row.sport}</span>
  }, {
    id: 'users',
    header: 'Usuários ativos',
    align: 'right',
    sortValue: row => row.users,
    cell: row => <span className="bee-num font-bold text-deep" data-id="element-1821" data-mp="2aaxrclpcp6po">
          {row.users.toLocaleString('pt-BR')}
        </span>
  }, {
    id: 'adoption',
    header: 'Adoção',
    align: 'right',
    sortValue: row => row.adoption,
    cell: row => <span className="bee-num text-deep" data-id="element-1822" data-mp="wz08y95qc15k">{row.adoption}%</span>
  }, {
    id: 'frequency',
    header: 'Frequência semanal',
    align: 'right',
    sortValue: row => row.frequency,
    cell: row => <span className="bee-num text-muted" data-id="element-1823" data-mp="16wegtkdl7hm9">{row.frequency.toFixed(1)}x</span>
  }, {
    id: 'trend',
    header: 'Tendência (90d)',
    align: 'right',
    sortValue: row => row.trend,
    cell: row => <span className={`bee-num font-bold ${row.trend >= 0 ? 'text-soft' : 'text-gold-deep'}`} data-id="element-1824" data-mp="e6z14haz90k0">
          {row.trend >= 0 ? '+' : ''}
          {row.trend.toFixed(1)}%
        </span>
  }];
  return <div className="space-y-4" data-id="element-1825" data-mp="3mpddn4ixdxqw">
      <AdminPageTitle title="Performance" subtitle="Adoção e uso das métricas esportivas, sempre em agregado. Nenhuma leitura aqui é interpretação clínica." action={<DateRange value={range} onChange={setRange} data-id="element-1827" data-mp="3jmh3y06y0m13" />} data-id="element-1826" data-mp="3mo2bta91j02f" />

      <section className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-1828" data-mp="3flnaysen8h1c">
        <AdminMetricCard label="Usuários com esporte ativo" value="119.800" delta={4.2} hint="Ao menos uma métrica registrada" accent data-id="element-1829" data-mp="3flezn4y65js9" />
        <AdminMetricCard label="Esporte mais adotado" value="Corrida" hint="32% da base" data-id="element-1830" data-mp="3oeikhyb58ywx" />
        <AdminMetricCard label="Frequência média" value="3,2x/semana" delta={1.6} data-id="element-1831" data-mp="30p65ght4xwmp" />
        <AdminMetricCard label="Métricas preenchidas" value="58,4%" delta={2.9} data-id="element-1832" data-mp="2wnujqnddtvjs" />
      </section>

      <DataTable rows={sportAdoption} columns={columns} rowKey={row => row.sport} pageSize={10} data-id="element-1833" data-mp="3anlt2asyenrg" />

      <div className="grid grid-cols-1 gap-3 xl:grid-cols-2" data-id="element-1834" data-mp="35pkbjub6ewi3">
        <AdminBarChart title="Adoção por esporte" question="Qual modalidade concentra a base ativa?" data={sportAdoption} xKey="sport" series={[{
        id: 'users',
        name: 'Usuários ativos'
      }]} horizontal data-id="element-1835" data-mp="pvabqck7vcne" />
        <Panel title="Uso das métricas" hint="Proporção de usuários do esporte que preenchem cada métrica." data-id="element-1836" data-mp="27tq6v4yr81y2">
          <DistributionList items={metricUsage.map(item => ({
          label: item.metric,
          value: item.usage
        }))} data-id="element-1837" data-mp="1tviaay5mr2nf" />
          <p className="mt-3 text-[11.5px] leading-snug text-muted" data-id="element-1838" data-mp="1yttk58vxdd5n">
            Métricas com pouco preenchimento indicam atrito no registro, não ausência de
            prática.
          </p>
        </Panel>
      </div>
    </div>;
}